import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  shell: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    background: `linear-gradient(180deg, ${designTokens.primary[800]} 0%, ${designTokens.primary[900]} 100%)`,
  },
  scrollWrapper: {
    flex: "1",
    minHeight: "0",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: designTokens.neutral.white,
  },
  panel: {
    outline: "none",
  },
});
